import { render, staticRenderFns } from "./ModalImportRestrictions.vue?vue&type=template&id=74ad3eec&lang=pug&"
import script from "./ModalImportRestrictions.vue?vue&type=script&lang=js&"
export * from "./ModalImportRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./ModalImportRestrictions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports